import React, { useState, useEffect, useRef } from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import section_7 from "../assets/images/section-7.png";
import { windowSize } from "../constants";
import { roadmap_list } from "../components/RoadmapData";
import useWindowDimensions from "../customHooks/useWindowDimension";
import useCalculateHeightRatio from "../customHooks/useCalculateHeightRatio";

import SimpleModal from "./overlayComponents/SimpleModal";

import "./Section7.scss";
import { galleryData } from "./GalleryData";

const Section7 = ({ JSONData }: any) => {
  const { content } = JSONData;
  const { main_header, description } = content;

  const [openModal, setOpenModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  const section7Element = useRef(null);

  const { width } = useWindowDimensions();
  const { heightRatio } = useCalculateHeightRatio({
    sectionImageHeight: section_7,
  });

  const smallerWidth = windowSize.iconWidthSize >= width;

  const toggleModalHandler = (description: any) => {
    setOpenModal(!openModal);

    if (openModal) {
      setModalMessage("");
    } else {
      setModalMessage(description);
    }
  };

  // useEffect(() => {
  //     const script = document.createElement('script');
  //     const div = document.createElement('div');
  //
  //     script.src = "https://apps.elfsight.com/p/platform.js";
  //     script.async = true;
  //
  //     div.className = "elfsight-app-1d302b6c-44bd-4f27-ae77-19b0c3736c1b";
  //
  //     // section7Element.current.appendChild(div);
  //     // section7Element.current.appendChild(script);
  //     //
  //     // return () => {
  //     //     section7Element.current.removeChild(script);
  //     // }
  //
  //     // <div className="elfsight-app-1d302b6c-44bd-4f27-ae77-19b0c3736c1b">{}</div>
  //
  // }, []);

  return (
    <Box
      id="Roadmap"
      className="section-7-container"
      ref={section7Element}
      style={{
        backgroundImage: `url(${section_7})`,
        minHeight: heightRatio.height,
      }}
    >
      <h1>{main_header}</h1>
      <h1 className="sub-header description">{description}</h1>
      <Stack className="roadmap-list">
        {roadmap_list &&
          roadmap_list.map((item: any, index: any) => {
            return (
              <span
                key={index}
                style={{ backgroundImage: `url(${roadmap_list[index].image})` }}
              >
                <p className={`title ${index % 2 === 0 ? "" : "even"}`}>
                  {roadmap_list[index].title}
                  {smallerWidth && (
                    <strong
                      onClick={() =>
                        toggleModalHandler(roadmap_list[index].description)
                      }
                    >
                      {" "}
                      see more...
                    </strong>
                  )}
                </p>
                <p
                  className={`${index % 2 === 0 ? "" : "even"} ${
                    smallerWidth ? "hidden" : ""
                  }`}
                >
                  {roadmap_list[index].description}
                </p>
              </span>
            );
          })}
      </Stack>
      <h1 className="second-header">Flying Frog Gallery</h1>
      <Box className="gallery-thumbnails">
        {galleryData &&
          galleryData.map((item: any, index: any) => {
            return (
              <img key={index} src={item} alt={`frog-thumbnail-${index}`} />
            );
          })}
      </Box>
      <SimpleModal
        modalMessage={modalMessage}
        toggleModalHandler={toggleModalHandler}
        openModal={openModal}
      />
    </Box>
  );
};

export default Section7;
